import { render } from "./GtrBasic.vue?vue&type=template&id=b9cdc6e4&scoped=true&ts=true"
import script from "./GtrBasic.vue?vue&type=script&lang=ts"
export * from "./GtrBasic.vue?vue&type=script&lang=ts"

import "./GtrBasic.vue?vue&type=style&index=0&id=b9cdc6e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cdc6e4"]])

export default __exports__